import clsx from 'clsx'
import Tooltip from '@mui/material/Tooltip'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { formatCurrencySinSignoPeso } from '../../utils/formatter'

const formatTransactionDayMonth = dateString => {
  if (!dateString) return null
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return null
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  return `${day}/${month}`
}

const ForeignAmountDetail = ({ movement, amount, className }) => {
  const currency = String(movement?.divisa ?? movement?.originalCurrency ?? '').trim().toUpperCase()
  const numericRate = Number(movement?.exchangeRate)
  const hasRate = Number.isFinite(numericRate) && numericRate > 0
  const storedAmount = movement?.amount != null && String(movement.amount).trim() !== ''
    ? movement.amount
    : movement?.originalAmount
  const hasOriginalAmount = storedAmount != null && String(storedAmount).trim() !== ''
  const originalAmount = hasOriginalAmount
    ? Math.abs(Number(storedAmount))
    : hasRate ? Math.abs(Number(amount)) / numericRate : NaN
  if (!currency || currency === 'CLP' || !Number.isFinite(Number(amount)) || !Number(amount) ||
    (hasOriginalAmount && !Number.isFinite(originalAmount))) return null

  const foreignAmount = Number.isFinite(originalAmount)
    ? new Intl.NumberFormat(currency === 'USD' ? 'en-US' : 'es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(originalAmount)
    : '—'
  const rate = hasRate ? formatCurrencySinSignoPeso(numericRate) : null
  const transactionDayMonth = formatTransactionDayMonth(movement.exchangeRateDate ?? movement.fecha)
  const rateLabel = !rate ? 'Tipo de cambio no disponible en este movimiento.' : transactionDayMonth
    ? `Valor del dólar ${transactionDayMonth}: $ ${rate}`
    : `Valor del dólar: $ ${rate}` 

  return (
    <p className={clsx('flex w-full items-center justify-center gap-1 text-[0.6rem] font-medium text-gray-400 sm:text-[0.705rem]', className)}>
      <span>{currency} ${foreignAmount}</span>
      {(rate || currency === 'USD') && (
        <Tooltip
          title={rateLabel}
          placement='top'
          enterTouchDelay={0}
          componentsProps={{ tooltip: { sx: {
            bgcolor: '#000033', color: '#fff', borderRadius: '6px',
            fontFamily: 'Inter, Nunito, system-ui, sans-serif', fontSize: '10px',
            fontWeight: 500, padding: '4px 8px'
          } } }}
        >
          <button
            type='button'
            className='inline-flex shrink-0 items-center justify-center rounded-full text-gray-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent2'
            aria-label={rateLabel}
            onClick={event => event.stopPropagation()}
          >
            <HelpOutlineOutlinedIcon aria-hidden='true' sx={{ fontSize: 14 }} />
          </button>
        </Tooltip>
      )}
    </p>
  )
}

export default ForeignAmountDetail
